import FloatButton from "./FloatButton";

export default function ProjectsFloatButton() {
  return <div style={{ position: 'absolute', top: '445px', left: '800px' }} >
    <FloatButton text="Projects" />
  </div>;
}